import { faDesktop, faHouse } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { HelpActionCard } from './cards/help-action-card.component';
import { FaqLoginButton } from './buttons/faq-login-button.component';
import { FaqUnitButton } from './buttons/faq-unit-button.component';

import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

export const RescheduleCancelSection = () => {
  return (
    <section className="flex flex-col gap-5 w-full pt-10">
      <Typography
        variant={TypographyVariant.MEDIUM_SUBTITLE}
        as="h2"
        className="font-bold text-gray-900"
      >
        Reagendamento e Cancelamento
      </Typography>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        <HelpActionCard
          icon={faHouse}
          title="Agendei pela unidade física"
          description="Entre em contato com a unidade onde realizou o agendamento para consultar as regras e solicitar o cancelamento ou fazer o reagendamento."
          testId={DataTestIdEnum.FAQ_RESCHEDULE_BRANCH_CARD}
          action={(
            <FaqUnitButton
              label="Procurar unidades"
              variant="default"
              className="w-full"
              showIcon={false}
            />
          )}
        />
        <HelpActionCard
          icon={faDesktop}
          title="Agendei pelo site ou aplicativo"
          description="Para agendamentos pelo site, consulte os Termos de Uso no seu cadastro e, quando disponível, cancele ou reagende em Meus Agendamentos no site/app."
          testId={DataTestIdEnum.FAQ_RESCHEDULE_ONLINE_CARD}
          action={(
            <FaqLoginButton
              label="Acessar meus agendamentos"
              variant="default"
              className="w-full"
            />
          )}
        />
      </div>
    </section>
  );
};
